// extracted by mini-css-extract-plugin
module.exports = {"container":"Overlays_container__FMfl9","layer":"Overlays_layer__ASnaG","overlay":"Overlays_overlay__3LjZQ"};